export default __webpack_public_path__ + "static/media/white_upload.674b5851.svg";